import React from 'react';

import { urls } from 'config/constants';

import IconDiscord from './icons/IconDiscord';
import IconTelegram from './icons/IconTelegram';
import IconTwitter from './icons/IconTwitter';
/** Social links in: Footer (Desktop), More Page (Mobile) */
export const socialLinksIconsList = [
  {
    name: 'Blog',
    link: urls.socialBlog,
  },
  {
    name: '𝕏',
    link: urls.socialX,
    icon: <IconTwitter />,
  },
  {
    name: 'Discord',
    link: urls.socialDiscord,
    icon: <IconDiscord />,
  },
  {
    name: 'Telegram',
    link: urls.socialTelegram,
    icon: <IconTelegram />,
  },
];
